import { apiClient } from './client';

export function getTaxonomies (shopId: number | string, page?: number) {
  return apiClient.get(`/${shopId}/taxonomy`, { params: { page } });
}

export function saveTaxonomies (shopId: number | string, payload: Record<string, unknown>) {
  return apiClient.post(`/${shopId}/taxonomy/save`, payload);
}

export function uploadTaxonomyCsv (shopId: number | string, formData: FormData) {
  return apiClient.post(`/${shopId}/taxonomy/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteTaxonomy (
  shopId: number | string,
  taxonomyId: number | string,
) {
  return apiClient.delete(`/${shopId}/taxonomy/${taxonomyId}`);
}

export function bulkDeleteTaxonomies (
  shopId: number | string,
  taxonomyIds: Array<number | string>,
) {
  return apiClient.post(`/${shopId}/taxonomy/bulk-delete`, {
    taxonomy_ids: taxonomyIds,
  });
}

export function previewCsvDelete (shopId: number | string, formData: FormData) {
  return apiClient.post(`/${shopId}/taxonomy/delete-preview`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function uploadDeleteCsv (shopId: number | string, formData: FormData) {
  return apiClient.post(`/${shopId}/taxonomy/delete-upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
